import { toCurrencyString } from '../helpers/numberHelpers'
import SplitClient from "./splitClient";
import * as sessionHelpers from "../helpers/sessionHelpers";

export const formattedPhone = (number) => {
  if (number == null || number.length !== 10) return number

  const digits = number.split('')
  return `(${digits.slice(0, 3).join('')}) ${digits.slice(3, 6).join('')}-${digits.slice(6, 10).join('')}`
}

// Function to give a default string if value is missing or blank
export const displayField = (str) => {
  return [null, undefined, ''].includes(str) ? '--' : str
}

// Function to give a default string if number value is missing or blank
export const displayCurrency = (val) => {
  return [null, undefined, ''].includes(val) ? '--' : toCurrencyString(val)
}

export const isDashboardV2 = async () => {
  const treatment = await SplitClient.getTreatment("SHOP_ORDERS",{ email: sessionHelpers.getApplicationCookie('current_user_email') })
  return treatment.SHOP_ORDERS === 'V2'
}

